import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import * as echarts from 'echarts';
import _ from 'lodash'

Vue.config.productionTip = false

Vue.prototype.$echarts = echarts;

window.$ = x => {
  const o = [...document.querySelectorAll(x)]
  return _.size(o) === 1 ? o[0] : o
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
